import CitySEOHead from "@/components/feature/CitySEOHead";
import LeeSummitHeroSection from "./components/HeroSection";
import LeeSummitStickyNav from "./components/StickyNav";
import LeeSummitProcessingTimeSection from "./components/ProcessingTimeSection";
import LeeSummitServicesSection from "./components/ServicesSection";
import LeeSummitLocalAreaSection from "./components/LocalAreaSection";
import LeeSummitDestinationsSection from "./components/DestinationsSection";
import LeeSummitTestimonialsSection from "./components/TestimonialsSection";
import LeeSummitAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LeeSummitComparisonSection from "./components/ComparisonSection";
import LeeSummitMistakesSection from "./components/MistakesSection";
import LeeSummitHowItWorksSection from "./components/HowItWorksSection";
import LeeSummitFAQSection, { faqs } from "./components/FAQSection";
import LeeSummitHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LeeSummitFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LeeSummitPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lee's Summit"
        state="Missouri"
        stateAbbr="MO"
        route="/lees-summit"
        title="Emergency Passport Lee's Summit, MO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lee's Summit, MO — as fast as 24 hours. No appointment scramble at the KC agency. A+ BBB rated, registered State Dept. courier serving Jackson County business travelers, Longview CC students, and families in Lee's Summit, Blue Springs, Grain Valley, and Raytown."
        geoPlacename="Lee's Summit, Missouri"
        geoPosition="38.9108;-94.3827"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Missouri"
        statePageRoute="/states/missouri"
      />
      <LeeSummitHeroSection />
      <LeeSummitStickyNav />
      <LeeSummitProcessingTimeSection />
      <LeeSummitLocalAreaSection />
      <LeeSummitServicesSection />
      <LeeSummitDestinationsSection />
      <LeeSummitTestimonialsSection />
      <LeeSummitAcceptanceFacilitiesSection />
      <LeeSummitComparisonSection />
      <LeeSummitMistakesSection />
      <LeeSummitHowItWorksSection />
      <LeeSummitFAQSection />
      <LeeSummitHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lees-summit" state="MO" />
      <LeeSummitFinalCTA />
    </div>
  );
}